module.exports = __webpack_public_path__ + "img/STERiGLIDE_01.98f08835.jpg";